import { render } from "./App.vue?vue&type=template&id=4195f020"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4195f020&lang=scss"
script.render = render

export default script